import { removeInvalidItems } from '@/services/adapters/transformations/removeInvalidItems'
import { IDataStore } from '@/services/dataStore/IDataStore'
import useDataStore from '@/services/dataStore/useDataStore'
import { BaseDataLayerSchema, IBaseDataLayer } from '@lifk/types'
import useSWRV from 'swrv'
import { z } from 'zod'

const useGetDataLayers = () => {
  const {
    dataStore,
    dataStoreSWRVKey,
    handleDataStoreError,
    disableValidations
  } = useDataStore()

  async function getDataLayers(
    dataStore: IDataStore
  ): Promise<IBaseDataLayer[]> {
    try {
      const response = await dataStore.getDataLayers()

      const validation = z.array(BaseDataLayerSchema).safeParse(response)
      let dataLayers: IBaseDataLayer[] = validation.data ?? []
      if (!validation.success) {
        dataLayers = removeInvalidItems(
          response,
          validation.error,
          disableValidations.value
        )
      }

      return dataLayers
    } catch (e) {
      handleDataStoreError(e)
      return []
    }
  }

  const result = useSWRV(
    () => `/data-layers/${dataStoreSWRVKey.value.perspective}`,
    async () => {
      return await getDataLayers(dataStore.value)
    },
    {
      // 30s for adapters to prevent too many API calls to paid CMS's
      dedupingInterval: 30000
    }
  )
  return result
}

export { useGetDataLayers }
